<template>
    <div id="app">
        <chatheader :logo="initialConfig.logo" :brand="initialConfig.brandName" :menu="initialConfig.menu"
            :inWidget="initialConfig.inWidget" :ttsEnabled="initialConfig.ttsEnabled" 
            :avatarvideo="initialConfig.avatarvideo" 
            :didBearer="initialConfig.didBearer" 
            :didAvatarVoiceType="initialConfig.didAvatarVoiceType" 
            :didAvatarVoiceId="initialConfig.didAvatarVoiceId">
        </chatheader>
        <messagecontainer :notificationKey="initialConfig.notificationKey" :user="parsedUser" :logo="initialConfig.logo"
            :brand="initialConfig.brandName" :language="initialConfig.language" :welcome="initialConfig.welcome"
            :action="initialConfig.action" :button="initialConfig.button" :platform="initialConfig.platform"
            :platformId="initialConfig.platformId" :websocket="initialConfig.websocket" :domain="initialConfig.domain"
            :start="start" :delay="initialConfig.delay" :reset="initialConfig.reset" :avatarvideo="initialConfig.avatarvideo">
        </messagecontainer>
        <chatfooter :autocomplete="initialConfig.autocomplete" :sttEnabled="initialConfig.sttEnabled">
        </chatfooter>
        <transition name="fade-scale">
            <dragAndDropUpload v-if="showUploadOverlay" :close-cb="closeUploadOverlay"></dragAndDropUpload>
        </transition>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css"

import chatheader from "@/components/ChatHeader.vue"
import chatfooter from "@/components/ChatFooter.vue"
import messagecontainer from "@/components/Messages.vue"
import dragAndDropUpload from "@/components/DragAndDropUpload.vue"

import {
    ContainsFiles
} from '@/utils/utils.js'

export default {
    name: 'app',
    components: {
        chatheader,
        chatfooter,
        messagecontainer,
        dragAndDropUpload
    },
    props: {
        initialConfig: Object
    },
    data() {
        return {
            parsedUser: {},
            start: {
                text: null,
                value: null
            },
            showUploadOverlay: false
        }
    },
    created() {
        const self = this
        let querystring = window.location.search ? window.location.search.substring(1) : ''
        let parser = require('querystrings')
        let parsed = parser.parse(querystring)

        this.start = {
            text: (typeof parsed.startText === 'undefined') ? this.initialConfig.start.text : self.stripHtml(decodeURIComponent(parsed.startText)),
            value: (typeof parsed.startValue === 'undefined') ? this.initialConfig.start.value : self.stripHtml(decodeURIComponent(parsed.startValue))
        }

        this.parsedUser = {
            id: parsed.id ? this.decodeParam(parsed.id) : this.decodeProp(this.initialConfig.user.id),
            notificationId: parsed.notificationId ? this.decodeParam(parsed.notificationId) : this.decodeProp(this.initialConfig.user.notificationId),
            fullName: parsed.fullName ? this.decodeParam(parsed.fullName) : this.decodeProp(this.initialConfig.user.fullName),
            firstName: parsed.firstName ? this.decodeParam(parsed.firstName) : this.decodeProp(this.initialConfig.user.firstName),
            lastName: parsed.lastName ? this.decodeParam(parsed.lastName) : this.decodeProp(this.initialConfig.user.lastName),
            email: parsed.email ? this.decodeParam(parsed.email) : this.decodeProp(this.initialConfig.user.email),
            extra: parsed.extra ? this.decodeParam(parsed.extra) : this.decodeProp(this.initialConfig.user.extra),
        }

        if (window.addEventListener) {
            // Open upload panel when files are dragged in
            window.addEventListener('dragenter', function (event) {
                self.showUploadOverlay = ContainsFiles(event)
            })
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    self.showUploadOverlay = false
                }
            })
        } else {
            // Open upload panel when files are dragged in
            window.attachEvent('ondragenter', function (event) {
                self.showUploadOverlay = ContainsFiles(event)
            })
            window.attachEvent('onkeydown', function (event) {
                if (event.key === 'Escape') {
                    self.showUploadOverlay = false
                }
            })
        }

    },
    methods: {
        decodeParam(param) {
            if (typeof param === 'undefined') {
                return null
            } else if (typeof param === 'object') {
                for (var property in param) {
                    if (param.hasOwnProperty(property)) {
                        if (typeof param[property] === 'object') {
                            param[property] = this.decodeParam(param[property])
                        } else {
                            param[property] = decodeURIComponent(param[property])
                        }
                    }
                }
                return param
            }
            return decodeURIComponent(param)
        },
        decodeProp(prop) {
            return (typeof prop === 'undefined') ? null : prop
        },
        closeUploadOverlay() {
            this.showUploadOverlay = false
        },
        stripHtml(string) {
            let doc = (new DOMParser()).parseFromString(string, 'text/html')
            return doc.body.textContent || ""
        },
    }
}
</script>

<style lang="scss">
// General app classes for all the project
@import "@/assets/fortawesome/fontawesome.scss";
@import "@/assets/fortawesome/solid.scss";

html,
body {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

body {
    &>div {
        width: 100%;
        height: 100%;
    }
}

#app {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all .4s ease;
    opacity: 1;
    transform: scale(1);
}

.fade-scale-enter,
.fade-scale-leave-to

/* .fade-scale-leave-active below version 2.1.8 */
    {
    opacity: 0;
    transform: scale(0.9);
}

.fade-scale-enter {
    transform: scale(0.8);
}
</style>
